"use strict";
/*
 * Copyright (c) "Neo4j"
 * Neo4j Sweden AB [http://neo4j.com]
 *
 * This file is part of Neo4j.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConcatOp = void 0;
exports.concat = concat;
const CypherASTNode_1 = require("../../CypherASTNode");
const ConcatOperator = "||";
/**
 * The concatenation operator (`||`) generated by {@link concat}
 * @group Operators
 * @category String
 */
class ConcatOp extends CypherASTNode_1.CypherASTNode {
    /** @internal */
    constructor(exprs) {
        super();
        this.exprs = exprs;
    }
    /**
     * @internal
     */
    getCypher(env) {
        const exprs = this.exprs.map((e) => e.getCypher(env));
        const operatorStr = ` ${ConcatOperator} `;
        return `(${exprs.join(operatorStr)})`;
    }
}
exports.ConcatOp = ConcatOp;
function concat(...exprs) {
    return new ConcatOp(exprs);
}
